import React from "react";

import styles from "./Privacidad.module.scss";
import { FormattedMessage } from "react-intl";

function Privacidad() {

    return (
        <div className={styles.main}>
            <div className={styles.wrap}>
                <div className={styles.logoBg} />
                <div className={styles.container}>
                    <div className={styles.textWrap}>
                        <div className={styles.title}><FormattedMessage id="privacy_title" /></div>
                        <div className={styles.text}>
                            <div>
                                <h3><FormattedMessage id="privacy_1_title" /></h3>
                                <p><FormattedMessage id="privacy_1_p1" /></p>

                                <h3><FormattedMessage id="privacy_2_title" /></h3>
                                <p><FormattedMessage id="privacy_2_p1" /></p>

                                <h3><FormattedMessage id="privacy_3_title" /></h3>
                                <p><FormattedMessage id="privacy_3_p1" /></p>
                                <ul>
                                    <li><FormattedMessage id="privacy_3_l1" /></li>
                                    <li><FormattedMessage id="privacy_3_l2" /></li>
                                    <li><FormattedMessage id="privacy_3_l3" /></li>
                                    <li><FormattedMessage id="privacy_3_l4" /></li>
                                </ul>
                                <p><FormattedMessage id="privacy_3_p2" /></p>

                                <h3><FormattedMessage id="privacy_4_title" /></h3>
                                <ul>
                                    <li><FormattedMessage id="privacy_4_l1" /></li>
                                    <li><FormattedMessage id="privacy_4_l2" /></li>
                                    <li><FormattedMessage id="privacy_4_l3" /></li>
                                    <li><FormattedMessage id="privacy_4_l4" /></li>
                                    <li><FormattedMessage id="privacy_4_l5" /></li>
                                </ul>

                                <h3><FormattedMessage id="privacy_5_title" /></h3>
                                <p><FormattedMessage id="privacy_5_p1" /></p>

                                <h3><FormattedMessage id="privacy_6_title" /></h3>
                                <p><FormattedMessage id="privacy_6_p1" /></p>
                                <p><FormattedMessage id="privacy_6_p2" /></p>

                                <h3><FormattedMessage id="privacy_7_title" /></h3>
                                <p><FormattedMessage id="privacy_7_p1" /></p>

                                <h3><FormattedMessage id="privacy_8_title" /></h3>
                                <p><FormattedMessage id="privacy_8_p1" /></p>
                                <ul>
                                    <li><FormattedMessage id="privacy_8_l1" /></li>
                                    <li><FormattedMessage id="privacy_8_l2" /></li>
                                    <li><FormattedMessage id="privacy_8_l3" /></li>
                                    <li><FormattedMessage id="privacy_8_l4" /></li>
                                    <li><FormattedMessage id="privacy_8_l5" /></li>
                                    <li><FormattedMessage id="privacy_8_l6" /></li>
                                </ul>
                                <p><FormattedMessage id="privacy_8_p2" /></p>

                                <h3><FormattedMessage id="privacy_9_title" /></h3>
                                <p><FormattedMessage id="privacy_9_p1" /></p>

                                <h3><FormattedMessage id="privacy_10_title" /></h3>
                                <p><FormattedMessage id="privacy_10_p1" /></p>

                                <h3><FormattedMessage id="privacy_11_title" /></h3>
                                <p><FormattedMessage id="privacy_11_p1" /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Privacidad;